import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const LinkToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#eeeeee",
    color: theme.palette.primary.main,
    fontSize: "14px",
    padding: "10px",
    boxShadow: theme.shadows[5],
    marginTop: 10,
    borderRadius: 0,
  },
}));

export default LinkToolTip;
